import { useState } from "react";
import userService from "services/user.service";
import Table from "./components/Table";
import ReportForm from "components/ReportForm";
import PageHeader from "components/PageHeader";
import sortAscending, { sortDescending } from "utils/sortData";

const Calls = ({ isLoggedIn }) => {
  const [employeesPhotos, setEmployeesPhotos] = useState(new Map());
  const [callsReport, setCallsReport] = useState("");
  const [formError, setFormError] = useState("");
  const [sorted, setSorted] = useState(false);
  const [currentColumn, setCurrentColumn] = useState("total_real_calls");
  const [lastUpdate, setLastUpdate] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [params, setParams] = useState({
    dateFrom: "",
    dateTo: "",
    employeesList: "",
  });

  const validate = (value) => {
    if (!value) {
      return "At least one team member must be selected.";
    }

    return "";
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    setParams(params);

    setShowButton(false);

    setFormError(validate(params?.employeesList));

    validate(params?.employeesList) === ""
      ? userService
          .getReport(
            "extension_calls/",
            params?.dateFrom,
            params?.dateTo,
            params?.employeesList
          )
          .then(
            (response) => {
              setShowButton(true);
              setLastUpdate(response?.data?.last_record_datetime);
              setCallsReport(
                (response?.data?.data).sort((a, b) => {
                  setSorted(true);
                  return sortAscending(a, b, "total_real_calls");
                })
              );
            },
            (error) => {
              const _content =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              setCallsReport(_content);
            }
          )
      : setCallsReport("");
  };

  const sortColumn = (columnName) => {
    if (currentColumn !== columnName) {
      setSorted(false);
      setCurrentColumn(columnName);
    }

    setSorted((prev) => !prev);

    callsReport.sort((a, b) => {
      if (currentColumn !== columnName) {
        return sortAscending(a, b, columnName);
      } else {
        return sorted
          ? sortDescending(a, b, columnName)
          : sortAscending(a, b, columnName);
      }
    });

    setCallsReport(callsReport);
  };

  return (
    <div className="container">
      <PageHeader title="Calls" details={lastUpdate} />
      <ReportForm
        isLoggedIn={isLoggedIn}
        handleOnSubmit={handleOnSubmit}
        showButton={showButton}
        params={params}
        formError={formError}
        employeesPhotos={employeesPhotos}
        setEmployeesPhotos={setEmployeesPhotos}
      />
      {employeesPhotos && (
        <Table
          callsReport={callsReport}
          photos={Object.fromEntries(employeesPhotos)}
          sortColumn={sortColumn}
        />
      )}
    </div>
  );
};

export default Calls;
